import _createForOfIteratorHelper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module engine/conversion/conversionhelpers
 */
/**
 * Base class for conversion helpers.
 */
var ConversionHelpers = /*#__PURE__*/function () {
  /**
   * Creates a conversion helpers instance.
   */
  function ConversionHelpers(dispatchers) {
    _classCallCheck(this, ConversionHelpers);
    this._dispatchers = dispatchers;
  }
  /**
   * Registers a conversion helper.
   *
   * **Note**: See full usage example in the `{@link module:engine/conversion/conversion~Conversion#for conversion.for()}`
   * method description.
   *
   * @param conversionHelper The function to be called on event.
   */
  _createClass(ConversionHelpers, [{
    key: "add",
    value: function add(conversionHelper) {
      var _iterator = _createForOfIteratorHelper(this._dispatchers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var dispatcher = _step.value;
          conversionHelper(dispatcher);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return this;
    }
  }]);
  return ConversionHelpers;
}();
export { ConversionHelpers as default };